import PropTypes from 'prop-types';
import { useState } from 'react';
import Modal from '../../../components/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronRight,
  faChevronDown
} from '@fortawesome/pro-solid-svg-icons';
import { Button } from 'react-bootstrap';

const PcsVocabularyPreviewModal = ({
  isOpen,
  onClose,
  vocabularies,
  addVocabularies
}) => {
  const [openedIds, setOpenedIds] = useState([0]); // first item opened

  const handleToggle = (index) => {
    setOpenedIds((prev) =>
      prev.includes(index)
        ? prev.filter((id) => id !== index)
        : [...prev, index]
    );
  };

  return (
    <Modal
      contentWidth="70%"
      isOpen={isOpen}
      titleName="Vocabulary Preview"
      onClose={onClose}
      disableBackdropClose={true}
    >
      <div className="vocabulary-preview">
        {vocabularies.map((item, index) => {
          const isOpen = openedIds.includes(index);

          return (
            <div
              key={index}
              className={`vocabulary-card ${isOpen ? 'open' : ''}`}
            >
              <div
                className="vocabulary-preview-header"
                onClick={() => handleToggle(index)}
              >
                <span className="vocabulary-title">
                  {item.vocabulary}
                </span>

                <button className="expand-btn">
                  <FontAwesomeIcon
                    icon={isOpen ? faChevronDown : faChevronRight}
                  />
                </button>
              </div>

              {isOpen && (
                <div className="vocabulary-body" dangerouslySetInnerHTML={{ __html: item.definition }} />
              )}
            </div>
          );
        })}
      </div>
      <div className='d-flex flex-row align-items-center gap-3 justify-content-end mt-4'>
        <div>
          <Button variant='castleWhite'  className='btn-width' onClick={onClose}>Cancel</Button>
        </div>
        <div>
          <Button variant='castleRed' onClick={addVocabularies}>Add Vocabularies</Button>
        </div>
      </div>
    </Modal>
  );
};

PcsVocabularyPreviewModal.propTypes = {
  vocabularies: PropTypes.array.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  addVocabularies: PropTypes.func.isRequired
};

export default PcsVocabularyPreviewModal;